<template>
  <div class="">
    <h2 class="title white">Selecione o Tipo de Atendimento</h2>
    <div class="ui one column grid">
      <div class="column" style="float: left; width: 250px; margin: 0 auto;">
        <div class="option" @click="selectPriority(0)">
          <img :src="'/static/img/preferencial-00.png'" alt="">
        </div>
        <h2 class="label-white">Convencional</h2>
      </div>
    </div>
    <br>
      <div class="ui five column grid" style="margin-top: 10px;">
      <div class="column" style="display: grid;">
        <div class="option" @click="selectPriority(1)">
          <img :src="'/static/img/preferencial-01.png'" alt="">
        </div>
        <h2 class="label-white">Dificuldade de locomoção</h2>
      </div>
      <div class="column" style="display: grid;">
        <div class="option" @click="selectPriority(2)">
          <img :src="'/static/img/preferencial-02.png'" alt="">
        </div>
        <p class="label-white">Idosos (> 60 anos)</p>
        <br>
      </div>
      <div class="column" style="display: grid;">
        <div class="option" @click="selectPriority(3)">
          <img :src="'/static/img/preferencial-03.png'" alt="">
        </div>
        <p class="label-white">Gestantes</p>
        <br>
      </div>
      <div class="column" style="display: grid;">
        <div class="option" @click="selectPriority(4)">
          <img :src="'/static/img/preferencial-04.png'" alt="">
        </div>
        <p class="label-white">Criança de colo</p>
        <br>

      </div>
      <div class="column" style="display: grid;">
        <div class="option" @click="selectPriority(5)">
          <img :src="'/static/img/preferencial-05.png'" alt="">
        </div>
        <p class="label-white">Doenças ocultas</p>
        <br>
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
      ticket: Object
  },
  data() {
    return {
      msg: 'Por favor, selecione um atendimento',
      lang: 'pt-BR',
    }
  },
  mounted() {
    this.speak(this.msg);
  },
  methods: {
    speak(msg) {
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    falar() {
      let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      let recognition = SpeechRecognition ? new SpeechRecognition() : false
      recognition.lang = this.lang;
      recognition.interimResults = true;
    },
    selectPriority(type) {
      this.$emit('setPriority', type);
      this.$emit('buttonClicked', 'NameInput');
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 42px;
  font-weight: bold;
  font-family: 'Source Sans Light';
}
h2.label-white {
  margin-top: 4px;
  font-size: 28px;
  text-align: center;
  color: #fff;
}
p.label-white {
  text-align: center;
}
.option {
  height: 206px;
  margin: 0 auto;
  padding-top: 10px;
  background: #56ccf2;
  border-radius: 20px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.option img {
  width: 180px;
  height: 180px;;
  margin: 0 20px;
  background: #fff;
  border-radius: 500px;
}
.column p {
  margin: 0px;
  font-size: 28px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerPiority.vue